import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-piatto',
  templateUrl: './piatto.component.html',
  styleUrls: ['./piatto.component.css']
})
export class PiattoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
